import { render, staticRenderFns } from "./DocumentwithName.vue?vue&type=template&id=02f65643&"
import script from "./DocumentwithName.vue?vue&type=script&lang=js&"
export * from "./DocumentwithName.vue?vue&type=script&lang=js&"
import style0 from "./DocumentwithName.vue?vue&type=style&index=0&id=02f65643&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports